import React, { Component } from "react";
import "./common.css";
import "../fonts/venusrisingrg.ttf";
import Grid from "@mui/material/Grid";
import ClipLoader from "react-spinners/ClipLoader";
import { connect } from "react-redux";
import { loginBegin, autoLogin } from "../actions/loginactions";
import { moveToSignUpPage, moveToForgottenPage } from "../actions/routeactions";

class Signin extends Component {
  state = {
    email: "",
    password: "",
  };
  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.toSignUp = this.toSignUp.bind(this);
    this.toForgottenPassword = this.toForgottenPassword.bind(this);
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    dispatch(autoLogin());
  }

  changeEmail(e) {
    this.setState({
      email: e.target.value,
    });
  }

  changePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  signIn() {
    const { dispatch } = this.props;
    const { email, password } = this.state;

    dispatch(loginBegin(email, password, true));
  }

  renderSpinner() {
    return (
      <Grid item xs={12}>
        <ClipLoader
          color="#FFFFFF"
          sizeUnit={"%"}
          size={100}
          loading={this.state.loading}
        />
      </Grid>
    );
  }

  toSignUp() {
    const { dispatch } = this.props;
    dispatch(moveToSignUpPage());
  }

  toForgottenPassword() {
    const { dispatch } = this.props;
    dispatch(moveToForgottenPage());
  }

  renderButtons() {
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <div>
            <button
              id="loginbutton"
              className="bbe-button"
              onClick={this.signIn}
            >
              Login
            </button>
          </div>
        </Grid>
        <Grid item xs={12}>
          <p className="hyperlink" onClick={this.toSignUp}>
            <u>Sign Up</u>
          </p>
          <p className="hyperlink" onClick={this.toForgottenPassword}>
            <u>Forgotten Password?</u>
          </p>
        </Grid>
      </React.Fragment>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h1>Sign In</h1>
            </Grid>
            <Grid item xs={12}>
              <label className="label">Email</label>
            </Grid>
            <Grid item xs={12}>
              <div>
                <input
                  id="emailinput"
                  type="text"
                  className="textbox logintext"
                  onChange={this.changeEmail}
                />
              </div>
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <label id="passwordlabel">Password</label>
            </Grid>
            <Grid item xs={12}>
              <div>
                <input
                  id="passwordinput"
                  type="password"
                  className="textbox logintext"
                  onChange={this.changePassword}
                />
              </div>
            </Grid>
            {loading ? this.renderSpinner() : this.renderButtons()}
          </Grid>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.login.loading,
});

export default connect(mapStateToProps)(Signin);
